import React from "react";
import TopicLocationPage from "@/components/TopicLocationPage";
import { trainingTopics, trainingLocations } from "@/data/topicLocationData";

export default function FireSafetyYorkshire() {
  return <TopicLocationPage
    topic={trainingTopics.fire_safety}
    location={trainingLocations.yorkshire}
    seo={{
      title: "Fire Safety Training in Yorkshire | Livius Training",
      description: "Fire marshal and fire warden training across Yorkshire. Comply with the Regulatory Reform (Fire Safety) Order 2005. Half-day and Level 2 fire safety courses. On-site delivery or at our Boroughbridge centre.",
      canonical: "https://livius-training.co.uk/fire-safety-training-yorkshire"
    }}
  />;
}